import { render, staticRenderFns } from "./CopyStakeStreamersTable.vue?vue&type=template&id=72027c72&scoped=true&lang=pug"
import script from "./CopyStakeStreamersTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamersTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStreamersTable.vue?vue&type=style&index=0&id=72027c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72027c72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VSwitch,VTooltip})
